<kendo-floatinglabel [text]="'Прикачи документи'">
    <kendo-fileselect   [restrictions]="filesRestrictions" 
                        [disabled]="disabled"
                        [multiple]="multiple"
                        [showFileList]="showFileList"
                        (remove)="onRemove($event)"
                        (select)="onSelect($event)"
                        (valueChange)="valueChange($event)"
                        >
        <kendo-fileselect-messages  [dropFilesHere]="dropFileHereMessage"
                                    [select]="selectMessage"
                                    >
        </kendo-fileselect-messages>

        <ng-template kendoFileSelectFileInfoTemplate let-files>
            <div>
                <span>{{ files[0]?.name }}</span>
                <kendo-dropdownlist style="display: flex; width: 50%; position: right;"
                                    [data]="documentTypes"
                                    [defaultItem]="documentTypePlaceholder"
                                    [itemDisabled]="itemDisabled"
                                    textField="name"
                                    valueField="id"
                                    [(ngModel)]="files[0].rawFile['documentType']"
                                    >
                </kendo-dropdownlist>
            </div>
        </ng-template>
    </kendo-fileselect>
</kendo-floatinglabel>
